import L from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

/**
 * Vite-friendly Leaflet default-marker icon wiring.
 *
 * Leaflet v1 ships icon paths relative to its own CSS file, which Vite
 * doesn't preserve through bundling. We import the assets explicitly so the
 * pin renders without 404s.
 *
 * Importing this module from any component that uses Marker is enough — the
 * side effect runs once at module load.
 */

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
})
